import React from 'react';
import { SEO } from '../components/SEO';
export const PrivacyPage = () => {
  return <main data-id="element-1644" data-mp="2nz7wxnwgbky4">
      <SEO title="Privacybeleid | BKCustoms" description="Lees ons privacybeleid. BKCustoms respecteert uw privacy en beschermt uw persoonlijke gegevens volgens de geldende wetgeving." canonical="/privacybeleid" data-id="element-1645" data-mp="2nyzl7zc2eloi" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-20" data-id="element-1646" data-mp="2x1qvvwx49df3">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1647" data-mp="31zsgima6xkso">
          <div className="absolute inset-0 bg-black/90 z-10" data-id="element-1648" data-mp="31x6boueopje5"></div>
          <img src="https://images.unsplash.com/photo-1557597774-9d273605dfa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Privacy Policy" className="w-full h-full object-cover object-center" data-id="element-1649" data-mp="36x2fotndtatp" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1650" data-mp="3kqa4yenzpu88">
          <h1 className="text-4xl font-bold text-white mb-6" data-id="element-1651" data-mp="3polhix5o6iu5">Privacybeleid</h1>
        </div>
      </div>
      {/* Content Section */}
      <section className="bg-[#0a0a0a] py-16" data-id="element-1652" data-mp="2yrg746pofera">
        <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-1653" data-mp="2yo0t777qobrg">
          <div className="bg-[#0f0f0f] border border-[#222] rounded-lg p-8 md:p-10" data-id="element-1654" data-mp="2tqisu57sf4v2">
            <div className="prose prose-invert max-w-none" data-id="element-1655" data-mp="2pqqgdhf9wekf">
              <p className="text-white/80 mb-6" data-id="element-1656" data-mp="2kqlypo2mpdsm">
                <strong data-id="element-1657" data-mp="2krxcmgpsg1xg">Laatst bijgewerkt: 1 juni 2023</strong>
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1658" data-mp="3hh4pz1g974qa">
                1. Inleiding
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1659" data-mp="3dgkqhr87jp0z">
                BKCustoms, gevestigd te Almere, is verantwoordelijk voor de
                verwerking van persoonsgegevens zoals weergegeven in deze
                privacyverklaring.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1660" data-mp="4zhm1g0qmlr0">
                2. Contactgegevens
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1661" data-mp="8hoc8jsnzng">
                Website: www.bkcustoms.nl
                <br data-id="element-1662" data-mp="j4hz1cysj6gy" />
                Adres: Microfoonstraat 36, 1322 BN Almere
                <br data-id="element-1663" data-mp="o435s9k7cj48" />
                Telefoon: +31 (0)6 278 88 306
                <br data-id="element-1664" data-mp="o3b9ewis6hcw" />
                E-mail: info@bkcustoms.nl
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1665" data-mp="abwp8md50a49">
                3. Persoonsgegevens die wij verwerken
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1666" data-mp="eibiuillzfn">
                BKCustoms verwerkt uw persoonsgegevens doordat u gebruik maakt
                van onze diensten en/of omdat u deze zelf aan ons verstrekt.
                Hieronder vindt u een overzicht van de persoonsgegevens die wij
                verwerken:
              </p>
              <ul className="list-disc pl-6 text-white/80 mb-4" data-id="element-1667" data-mp="3rk1nlyoio0po">
                <li data-id="element-1668" data-mp="1lrv7ngu7g8i5">Voor- en achternaam</li>
                <li data-id="element-1669" data-mp="1lswjvomyj11g">Adresgegevens</li>
                <li data-id="element-1670" data-mp="1lpqs21my1l21">Telefoonnummer</li>
                <li data-id="element-1671" data-mp="1ptyiq4cypb2w">E-mailadres</li>
                <li data-id="element-1672" data-mp="1pswx55ybl66x">Gegevens over uw voertuig</li>
                <li data-id="element-1673" data-mp="3ab7qtshfyemv">Overige persoonsgegevens die u actief verstrekt</li>
              </ul>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1674" data-mp="369vzniix5lck">
                4. Doeleinden gegevensverwerking
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1675" data-mp="3k2c48nrgxrfl">
                BKCustoms verwerkt uw persoonsgegevens voor de volgende doelen:
              </p>
              <ul className="list-disc pl-6 text-white/80 mb-4" data-id="element-1676" data-mp="3f8r52se52ret">
                <li data-id="element-1677" data-mp="3ty5icbku5szh">Het afhandelen van uw betaling</li>
                <li data-id="element-1678" data-mp="3p0ndoxdupzxa">U te kunnen bellen of e-mailen indien nodig</li>
                <li data-id="element-1679" data-mp="3p2ho3hrhy9n4">U te informeren over onze diensten en wijzigingen</li>
                <li data-id="element-1680" data-mp="6th3rmi2pq83">Het uitvoeren van de overeenkomst</li>
                <li data-id="element-1681" data-mp="1vxk272lwl8r">
                  Voor het verzenden van onze nieuwsbrief (alleen met expliciete
                  toestemming)
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1682" data-mp="28nym7zjec67h">
                5. Bewaartermijn
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1683" data-mp="261z842kynde6">
                BKCustoms bewaart uw persoonsgegevens niet langer dan strikt
                nodig is om de doelen te realiseren waarvoor uw gegevens worden
                verzameld. Wij hanteren de volgende bewaartermijnen:
              </p>
              <ul className="list-disc pl-6 text-white/80 mb-4" data-id="element-1684" data-mp="2k1gu6a6vgcju">
                <li data-id="element-1685" data-mp="2k0p4th3vbb20">
                  Klantgegevens: 7 jaar (wettelijke bewaartermijn
                  belastingdienst)
                </li>
                <li data-id="element-1686" data-mp="1rc9u36rrrewh">Gegevens voor marketingdoeleinden: 2 jaar</li>
              </ul>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1687" data-mp="1wbw99lr5r57x">
                6. Delen van persoonsgegevens met derden
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1688" data-mp="213e9u8p9r3sd">
                BKCustoms verkoopt uw gegevens niet aan derden en verstrekt deze
                uitsluitend indien dit nodig is voor de uitvoering van onze
                overeenkomst met u of om te voldoen aan een wettelijke
                verplichting.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1689" data-mp="1120yul72emid">
                7. Cookies en vergelijkbare technieken
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1690" data-mp="r43ck38rmzse">
                BKCustoms gebruikt alleen technische, functionele en analytische
                cookies die geen inbreuk maken op uw privacy. Een cookie is een
                klein tekstbestand dat bij het eerste bezoek aan deze website
                wordt opgeslagen op uw computer, tablet of smartphone.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1691" data-mp="8e4vixmzpwcm">
                8. Uw rechten
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1692" data-mp="3fk4notmop0u">
                U heeft het recht om uw persoonsgegevens in te zien, te
                corrigeren of te verwijderen. Daarnaast heeft u het recht om uw
                eventuele toestemming voor de gegevensverwerking in te trekken
                of bezwaar te maken tegen de verwerking van uw persoonsgegevens
                door BKCustoms.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1693" data-mp="3kxzgz3sagpi9">
                9. Wijzigingen in deze privacyverklaring
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1694" data-mp="37016i9h39d81">
                BKCustoms kan deze privacyverklaring aanpassen. De meest actuele
                versie vindt u altijd op onze website.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1695" data-mp="3jc6z7fxb3rv">
                10. Contact
              </h2>
              <p className="text-white/80" data-id="element-1696" data-mp="3pwtxu06p43zq">
                Als u vragen heeft over deze privacyverklaring, neem dan contact
                met ons op via info@bkcustoms.nl.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>;
};